module.exports = "/_next/static/images/eb448d775dc1de53ffda02ece4de50af-moneybox-icon.svg";